import { Link } from "react-router-dom";

export function PublicHeader() {
  return (
    <header className="public-topbar lf-header">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <Link className="public-brand lf-brand" to="/" aria-label="Middlemen and Company home">
        <span className="brand-mark" aria-hidden="true">M</span>
        <span>
          <b>MIDDLEMEN &amp; CO.</b>
          <small>THE MOMMI LIVE NETWORK</small>
        </span>
      </Link>
      <nav className="lf-header-nav" aria-label="Main navigation">
        <a href="/#task-check">TASK CHECK</a>
        <a href="/#placement">TASK TYPES</a>
        <a href="/#network">NETWORK</a>
        <a href="/#payouts">PAYOUTS</a>
      </nav>
      <div className="public-actions lf-header-actions">
        <Link className="lf-login-link" to="/login">MEMBER LOGIN</Link>
        <Link className="lf-button lf-button-primary lf-header-cta" to="/apply">JOIN THE PLATFORM</Link>
      </div>
    </header>
  );
}
